import type { EnrichedContentIndexable } from "@/src/models/intake/blocks/enriched-content";
import {
  type StediEligibilityCheck,
  type VerifyInsuranceEligibilityResponse,
  verifyInsuranceEligibilityResponseSchema,
} from "@/src/models/stedi-eligibility-check";
import { fetchJSON } from "@/src/requests/utils/fetch-json";

export async function getEligibilityCheckByReferralId(referralId: string): Promise<StediEligibilityCheck | null> {
  return fetchJSON<StediEligibilityCheck | null>(`/api/referrals/${referralId}/eligibility`);
}

export async function getEligibilityCheckByTaskId(taskId: string): Promise<StediEligibilityCheck | null> {
  return fetchJSON<StediEligibilityCheck | null>(`/api/tasks/${taskId}/eligibility`);
}

export async function getEligibilityCheckByOrderId(orderId: string): Promise<StediEligibilityCheck | null> {
  return fetchJSON<StediEligibilityCheck | null>(`/api/orders/${orderId}/eligibility`);
}

export type VerifyInsuranceEligibilityRequestPayload = {
  enrichedContent: EnrichedContentIndexable;
  force?: boolean;
};

export async function verifyInsuranceEligibilityAtIntake(
  taskId: string,
  payload: VerifyInsuranceEligibilityRequestPayload
): Promise<VerifyInsuranceEligibilityResponse> {
  return verifyInsuranceEligibilityResponseSchema.parse(
    await fetchJSON<VerifyInsuranceEligibilityResponse>(`/api/tasks/${taskId}/verify-insurance-eligibility`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    })
  );
}

export async function recheckOrderEligibility(
  orderId: string,
  force: boolean = true
): Promise<VerifyInsuranceEligibilityResponse> {
  return verifyInsuranceEligibilityResponseSchema.parse(
    await fetchJSON<VerifyInsuranceEligibilityResponse>(`/api/orders/${orderId}/eligibility`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ force }),
    })
  );
}

export async function recheckTaskEligibility(taskId: string): Promise<VerifyInsuranceEligibilityResponse> {
  return verifyInsuranceEligibilityResponseSchema.parse(
    await fetchJSON<VerifyInsuranceEligibilityResponse>(`/api/tasks/${taskId}/eligibility`, { method: "POST" })
  );
}
